export enum PaymentMethodType {
  Particular = 1,
  HealthInsurance = 2,
}
